import { render, staticRenderFns } from "./UnresolveInfectionCase.vue?vue&type=template&id=74af969a&"
import script from "./UnresolveInfectionCase.vue?vue&type=script&lang=js&"
export * from "./UnresolveInfectionCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports